module.exports = __webpack_public_path__ + "img/code.a32ebdfd.png";